import { UserData } from './types';
import { DEFAULT_INDUSTRY_ID, DEFAULT_STRUCTURE_ID } from './caas/caasConsts';

const WIX_SOCIAL_LINK_FACEBOOK = 'https://www.facebook.com/wix';
const WIX_SOCIAL_LINK_INSTAGRAM = 'https://www.instagram.com/wix';
const WIX_SOCIAL_LINK_X = 'https://x.com/wix';
const WIX_SOCIAL_LINK_TIKTOK = 'https://www.tiktok.com/@wix';

export const DEFAULT_WIX_SOCIAL_LINKS = [
  WIX_SOCIAL_LINK_FACEBOOK,
  WIX_SOCIAL_LINK_INSTAGRAM,
  WIX_SOCIAL_LINK_X,
  WIX_SOCIAL_LINK_TIKTOK,
];

export const TEMP_USER_DATA: UserData = {
  businessName: 'businessName',
  businessTypeName: 'businessTypeName',
  industryId: DEFAULT_INDUSTRY_ID,
  structureId: DEFAULT_STRUCTURE_ID,
  email: 'info@mysite.com',
  address: {
    googleFormattedAddress: '500 Terry Francine St. San Francisco, CA 94158',
  },
  phoneNumber: '123-456-7890',
  socialLinks: DEFAULT_WIX_SOCIAL_LINKS,
  description: 'business description',
};

export enum ContentKind {
  TEXT = 'text',
  MEDIA = 'media',
  ALL = 'all',
}

export const languageCodeToLanguageName: { [languageCode: string]: string } = {
  de: 'German',
  en: 'English',
  es: 'Spanish',
  fr: 'French',
  it: 'Italian',
  ja: 'Japanese',
  ko: 'Korean',
  pl: 'Polish',
  ru: 'Russian',
  nl: 'Dutch',
  tr: 'Turkish',
  sv: 'Swedish',
  pt: 'Portuguese',
  no: 'Norwegian',
  da: 'Danish',
  hi: 'Hindi',
  zh: 'Chinese',
  cs: 'Czech',
  th: 'Thai',
  uk: 'Ukrainian',
  vi: 'Vietnamese',
  id: 'Indonesian',
};
